import { createFileRoute } from "@tanstack/react-router";
import { TutorJoinPage } from "@/components/partners/TutorJoinPage";
import { tutorJoinHead } from "@/components/partners/tutor-join-head";

// «Для репетиторов и кружков» (ru, старый адрес без префикса: работает, canonical — /ru/tutors/join).
export const Route = createFileRoute("/tutors/join")({
  head: () => tutorJoinHead("ru"),
  component: () => <TutorJoinPage lang="ru" />,
});
